import { Injectable } from '@angular/core';
import {
	HttpInterceptor,
	HttpRequest,
	HttpHandler,
	HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './index';

/**
 * HTTP Interceptor that automatically adds JWT token to requests
 *
 * This interceptor:
 * - Adds Authorization header to authenticated API requests
 * - Skips token for public endpoints only when no token exists (login page)
 * - Adds token to public endpoints when authenticated
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(private readonly authService: AuthService) {}

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		const token = this.authService.getAccessToken();

		// Check if this request should have authentication
		if (this.shouldAddToken(request.url, token)) {
			if (token) {
				// Clone the request and add Authorization header
				request = request.clone({
					setHeaders: {
						Authorization: `Bearer ${token}`,
					},
				});
			}
		}

		return next.handle(request);
	}

	/**
	 * Determine if we should add token to this request
	 */
	private shouldAddToken(url: string, token: string | null): boolean {
		// Public endpoint for Login page
		const conditionalPublicEndpoints = ['/api/mongo/authProvider'];

		// Check if URL matches a conditional public endpoint
		const isConditionalPublic = conditionalPublicEndpoints.some((endpoint: string) =>
			url.includes(endpoint)
		);

		if (isConditionalPublic) {
			return !!token;
		}

		// Add token to all other /api/ requests
		return url.includes('/api/');
	}
}
